var map = {
	"./accounting/accounting.module": [
		"./src/app/pages/accounting/accounting.module.ts",
		"default~accounting-accounting-module~reservation-reservation-module",
		"common",
		"accounting-accounting-module"
	],
	"./miscellaneous/miscellaneous.module": [
		"./src/app/pages/miscellaneous/miscellaneous.module.ts",
		"common"
	],
	"./reservation/reservation.module": [
		"./src/app/pages/reservation/reservation.module.ts",
		"default~accounting-accounting-module~reservation-reservation-module",
		"common",
		"reservation-reservation-module"
	],
	"app/pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"common",
		"app-pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;